import { inject, Injectable } from "@angular/core";
import { isPropertyDefined } from "@recursyve/nice-ts-utils";
import { NiceAsyncTypeaheadProvider, NiceAsyncTypeaheadSearchResult } from "@recursyve/nice-ui-kit.v2";
import { lastValueFrom, Observable } from "rxjs";
import { map } from "rxjs/operators";
import { ApiService } from "../../api.service";
import { FindOptionsDto } from "../../common/dto/find-options.dto";
import { FindSuppliersDto } from "../dto/find-suppliers.dto";
import { SuppliersStatus } from "../enums/suppliers-status.enum";
import { Suppliers } from "../models/suppliers.model";

export interface SupplierTypeaheadOptions extends FindOptionsDto {
    status?: SuppliersStatus;
}

@Injectable()
export class SupplierTypeaheadApi extends NiceAsyncTypeaheadProvider<Suppliers> {
    private readonly api = inject(ApiService);

    public readonly resource = "suppliers";

    private readonly pageSize = 20;

    public override async getById(id: number): Promise<Suppliers> {
        return lastValueFrom(this.api.suppliers.getById(id));
    }

    public override search(
        searchQuery: string,
        page: number,
        options?: SupplierTypeaheadOptions
    ): Observable<NiceAsyncTypeaheadSearchResult<Suppliers>> {
        const dto: FindSuppliersDto = {
            searchQuery,
            page,
            pageSize: this.pageSize
        };

        if (isPropertyDefined(options, "status")) {
            dto.status = options.status;
        }

        if (isPropertyDefined(options, "ignoreIds")) {
            dto.ignoreIds = options.ignoreIds.map((x) => x);
        }

        return this.api.suppliers
            .getAll(dto)
            .pipe(map((items) => ({ items, nextPage: items.length === this.pageSize ? page + 1 : null })));
    }

    public override format(item: Suppliers): string {
        if (typeof item.name === "string") {
            return item.name;
        }

        return "";
    }
}
